import { render, staticRenderFns } from "./RoleMana.vue?vue&type=template&id=80ee667c&"
import script from "./RoleMana.vue?vue&type=script&lang=js&"
export * from "./RoleMana.vue?vue&type=script&lang=js&"
import style0 from "./RoleMana.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports